var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMIconNavInventoriesWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 11.25H14.625V12H11.625V11.25ZM18 10.125V16C18 17.1046 17.1046 18 16 18H2C0.89543 18 0 17.1046 0 16V10.125C0 9.09075 0.84075 8.25 1.875 8.25H3.75V1.875C3.75 0.84075 4.59075 0 5.625 0H12.375C13.4093 0 14.25 0.84075 14.25 1.875V8.25H16.125C17.1593 8.25 18 9.09075 18 10.125ZM4.5 8.25H13.5V1.875C13.5 1.25475 12.9952 0.75 12.375 0.75H5.625C5.00475 0.75 4.5 1.25475 4.5 1.875V8.25ZM0.75 16.25C0.75 16.8023 1.19772 17.25 1.75 17.25H7.625C8.17728 17.25 8.625 16.8023 8.625 16.25V10C8.625 9.44772 8.17728 9 7.625 9H1.875C1.25475 9 0.75 9.50475 0.75 10.125V16.25ZM17.25 10.125C17.25 9.50475 16.7452 9 16.125 9H10.375C9.82272 9 9.375 9.44772 9.375 10V16.25C9.375 16.8023 9.82272 17.25 10.375 17.25H16.25C16.8023 17.25 17.25 16.8023 17.25 16.25V10.125ZM3.375 11.25V12H6.375V11.25H3.375ZM7.5 3.75H10.5V3H7.5V3.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMIconNavInventoriesWhite);
export default __webpack_public_path__ + "static/media/m-icon-nav-inventories-white.a7014864f22b97856ca12b80474c4bb9.svg";
export { ForwardRef as ReactComponent };